<div class="security-container">
  <div class="security-content">
    <div class="password-section">

      <div class="flex flex-column gap-1 mb-4">
        <span class="section-title">Modification du mot de passe</span>
        <span class="section-description">
          Utilisez un mot de passe fort contenant lettres, chiffres et caract&egrave;res sp&eacute;ciaux.
        </span>
      </div>

      <form [formGroup]="formGroup" (submit)="onSubmit()" class="flex flex-column gap-4">
        <div class="form-grid">

          <div class="field-group full-width">
            <label for="lastPassword">Ancien mot de passe</label>
            <p-password
              id="lastPassword"
              formControlName="oldPassword"
              [feedback]="false"
              [toggleMask]="true"
              autocomplete="off"
              styleClass="w-full">
            </p-password>
          </div>

          <div class="field-group">
            <label for="newPassword">Nouveau mot de passe</label>
            <p-password
              id="newPassword"
              formControlName="newPassword"
              [toggleMask]="true"
              styleClass="w-full"
              autocomplete="off"
              appendTo="body">
            </p-password>
          </div>

          <div class="field-group">
            <label for="confirmPassword">Confirmation du mot de passe</label>
            <p-password
              id="confirmPassword"
              formControlName="confirmPassword"
              [toggleMask]="true"
              styleClass="w-full"
              autocomplete="off"
              appendTo="body">
            </p-password>
          </div>

        </div>

        <div class="flex justify-content-end gap-3">
          <div class="flex align-items-center gap-3">
            <form [formGroup]="twoFactorGroup">
              <div class="flex align-items-center gap-2">
                <p-checkbox (onChange)="toggleTwoFactor($event)" [binary]="true" id="twoFactor" formControlName="twoFactor" />
                <label for="twoFactor" class="text-sm">Authentification &agrave; double facteurs</label>
              </div>
            </form>
          </div>
          <p-button
            label="Mettre &agrave; jour"
            icon="pi pi-save"
            [loading]="isLoading"
            [disabled]="!formGroup.valid"
            styleClass="primary-btn"
            (onClick)="onSubmit()">
          </p-button>
        </div>
      </form>

    </div>
  </div>
</div>
